export var getErrorContent = function getErrorContent(_ref) {
  var error = _ref.error,
    withLengthCounter = _ref.withLengthCounter,
    value = _ref.value,
    maxLength = _ref.maxLength;
  if (error) {
    return error;
  }
  if (withLengthCounter && maxLength && ((value === null || value === void 0 ? void 0 : value.length) || 0) >= maxLength) {
    return 'Достигнут лимит символов';
  }
  return undefined;
};